import { useContext, createContext } from 'react';

export const DeliverFormContext = createContext();

export const useDeliverForm = () => {
  const context = useContext(DeliverFormContext);

  if (!context) {
    throw new Error(
      `useNotification must be used within a NotificationProvider`,
    );
  }
  return context;
};
